export default {
    init() {
        var rotate = {
            init: function() {
                rotate.text = ["Ello", "Aye", "Hello", "Hola", "Buenas", "Ola", "Ei", "你好", "E'yo"];
                rotate.counter = 0;
                rotate.elem = document.getElementById("js-rotate");
                rotate.elem.innerText = rotate.text[rotate.counter] + ".";
                rotate.inst = setInterval(rotate.change, 3000);
            },
            change: function() {
                rotate.elem.innerText = rotate.text[rotate.counter] + ".";
                rotate.counter++;
                if (rotate.counter >= rotate.text.length) {
                    rotate.counter = 0;
                    // clearInterval(rotate.inst);
                }
            },
        };
        rotate.init();
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/contacto.js